<template>
  <div>
    <bs-card class="card-info" :icon="icon" :label="labels.name">
      <template v-slot:header>
        <bs-button class="btn-sm btn-info" @click="create">{{ labels.create }}</bs-button>
      </template>
      <bs-table v-bind="{dataLength, loading}" :cols="6">
        <template v-slot:thead>
          <tr>
            <bs-th :label="$tc('labels.project_worker', 1)"></bs-th>
            <bs-th :label="$t('labels.started')"></bs-th>
            <bs-th :label="$t('labels.ended')"></bs-th>
            <bs-th :label="$t('labels.time')"></bs-th>
            <bs-th :label="$t('labels.description')"></bs-th>
            <bs-th scope="col"></bs-th>
          </tr>
        </template>
        <tr v-for="r in resources.data" :key="r.id">
          <td>
            <avatar class="mr-1" :user="find(users, 'id', r.user_id)" showName />
          </td>
          <td>{{ r.created_at | datetime }}</td>
          <td>{{ r.ended_at | datetime }}</td>
          <td>
            <span v-if="r.ended_at">{{ r.created_at | timediff(r.ended_at) }}</span>
            <timer class="badge py-1 px-2 bg-green" v-else :timer="r" />
          </td>
          <td>{{ r.description }}</td>
          <td class="t2">
            <bs-action :icon="['fal', 'pencil']" :tip="labels.edit" class="btn-info" @click="update(r)"></bs-action>
            <bs-action :icon="['fal', 'trash']" :tip="labels.delete" class="btn-danger" @click="destroy(r)"></bs-action>
          </td>
        </tr>
        <template v-slot:tfoot>
          <pagination :data="resources" :state="resourceState" @pushPage="index"></pagination>
        </template>
      </bs-table>
    </bs-card>
    <portal to="app-modal">
      <bs-modal :name="'create-' + $options.name" :label="resource.id ? labels.edit : labels.create">
        <bs-form :submit="$t('labels.submit')" @submit="submit">
          <template v-slot:default="{ error }">
            <tuxedo-input :name="'name'" :label="$t('labels.name')" v-model="resource.name" :error="error" />
          </template>
        </bs-form>
      </bs-modal>
      <bs-modal :name="'destroy-' + $options.name" :label="labels.delete">
        <bs-form :destroy="$t('labels.destroy')" @submit="destruction">
          {{ $t('messages.delete', { resource: camelToSpace(singular($options.name)) }) }}
        </bs-form>
      </bs-modal>
    </portal>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { resourceControl } from '../../mixins/resourceControl'

export default {
  name: 'ProjectTimers',
  mixins: [resourceControl],
  props: ['project'],
  data () {
    return {
      icon: ['fal', 'books'],
      resource: {
        name: ''
      }
    }
  },
  computed: {
    ...mapState({
      resources: state => state.projectTimers,
      resourceState: state => state.projectTimersState,
      users: state => state.usersStore
    }),
    apiTarget () { return ['projects', this.project, 'timers'] }
  }
}
</script>
